import { Injectable } from '@angular/core';
// import { Product } from './product';
import { SOFTWARE } from './product-list';
@Injectable()
export class DataService {
//   getSoftwareList(): Promise<Product[]> {
  getSoftwareList(): Promise<any> {
    return Promise.resolve(SOFTWARE);
  }
}